import { trackFolderTitle } from '../../../../../constants/tracks'
import {
  TrackAudioFile,
  TrackFolder,
  TracksAudioIndex,
} from '../../../../../firebase/utils/storageActions'
import { LogExercices } from '../../../../../types'

export interface TrackPickerLevel {
  depth: number
  legend: string
  options: string[]
  selected: string | null
}

export interface TrackPickerState {
  folderAvailable: boolean
  levels: TrackPickerLevel[]
  selectedPath: string[]
  selectionComplete: boolean
  tracks: TrackAudioFile[]
}

export const formatTrackCategoryLabel = trackFolderTitle

const levelLegend = (depth: number) => {
  if (depth === 0) return 'Categoría del ejercicio'
  if (depth === 1) return 'Tipo de entrenamiento'
  if (depth === 2) return 'Subcategoría del entrenamiento'
  return `Subcategoría ${depth} del entrenamiento`
}

const folderNames = (folder: TrackFolder) =>
  Object.keys(folder.folders).sort((first, second) =>
    first.localeCompare(second, 'es'),
  )

/**
 * Convierte el contrato histórico de la bitácora en una ruta de Storage:
 * category[0] / routine / category[1...].
 */
export const getExerciseTrackPath = (exercise: LogExercices): string[] => {
  const [root, ...nestedCategories] = exercise.category
  if (!root) return []

  const routine =
    exercise.routine && exercise.routine !== root ? [exercise.routine] : []

  return [root, ...routine, ...nestedCategories]
}

export const withExerciseTrackPath = (
  exercise: LogExercices,
  path: string[],
): LogExercices => {
  const [category, routine, ...nestedCategories] = path

  return {
    ...exercise,
    category: category ? [category, ...nestedCategories] : [],
    routine: routine ?? null,
    gender: null,
    exercise: { title: '', url: '' },
  }
}

export const withSelectedTrack = (
  exercise: LogExercices,
  track: TrackAudioFile | null,
): LogExercices => ({
  ...exercise,
  exercise: track ?? { title: '', url: '' },
  routine:
    track && !exercise.routine
      ? exercise.category[0] ?? null
      : exercise.routine,
})

export const getTrackPickerState = (
  index: TracksAudioIndex | null,
  exercise: LogExercices,
): TrackPickerState => {
  if (!index) {
    return {
      folderAvailable: false,
      levels: [],
      selectedPath: [],
      selectionComplete: false,
      tracks: [],
    }
  }

  const requestedPath = getExerciseTrackPath(exercise)
  const levels: TrackPickerLevel[] = []
  const selectedPath: string[] = []
  let currentFolder = index
  let depth = 0

  while (true) {
    const options = folderNames(currentFolder)

    if (options.length === 0) {
      return {
        folderAvailable: selectedPath.length > 0,
        levels,
        selectedPath,
        selectionComplete: selectedPath.length > 0,
        tracks: currentFolder.tracks,
      }
    }

    const requestedSelection = requestedPath[depth]
    const selected = options.includes(requestedSelection)
      ? requestedSelection
      : null

    levels.push({
      depth,
      legend: levelLegend(depth),
      options,
      selected,
    })

    if (!selected) {
      return {
        folderAvailable: selectedPath.length > 0,
        levels,
        selectedPath,
        selectionComplete: false,
        tracks: [],
      }
    }

    selectedPath.push(selected)
    currentFolder = currentFolder.folders[selected]
    depth += 1
  }
}
